module.exports = __webpack_public_path__ + "static/media/image-3.cb86b196.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EstablishingAVoiceForYourBrand/image-3.png
// module id = 407
// module chunks = 0